export const oracleTypesAbi = [
  {
    type: "function",
    name: "getChainlinkOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "chainlinkOracleInfo",
        type: "tuple",
        internalType: "struct ChainlinkOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "feed",
            type: "address",
            internalType: "address",
          },
          {
            name: "feedDescription",
            type: "string",
            internalType: "string",
          },
          {
            name: "maxStaleness",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getChainlinkInfrequentOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "chainlinkInfrequentOracleInfo",
        type: "tuple",
        internalType: "struct ChainlinkInfrequentOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "feed",
            type: "address",
            internalType: "address",
          },
          {
            name: "feedDescription",
            type: "string",
            internalType: "string",
          },
          {
            name: "maxStaleness",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getChronicleOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "chronicleOracleInfo",
        type: "tuple",
        internalType: "struct ChronicleOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "feed",
            type: "address",
            internalType: "address",
          },
          {
            name: "maxStaleness",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getCrossAdapterInfo",
    inputs: [],
    outputs: [
      {
        type: "tuple",
        name: "cross",
        internalType: "struct CrossAdapterInfo",
        components: [
          { type: "address", name: "base" },
          { type: "address", name: "cross" },
          { type: "address", name: "quote" },
          { type: "address", name: "oracleBaseCross" },
          { type: "address", name: "oracleCrossQuote" },
          {
            type: "tuple",
            name: "oracleBaseCrossInfo",
            components: [
              { type: "address", name: "oracle" },
              { type: "string", name: "name" },
              { type: "bytes", name: "oracleInfo" },
            ],
          },
          {
            type: "tuple",
            name: "oracleCrossQuoteInfo",
            components: [
              { type: "address", name: "oracle" },
              { type: "string", name: "name" },
              { type: "bytes", name: "oracleInfo" },
            ],
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getEulerRouterInfo",
    inputs: [],
    outputs: [
      {
        type: "tuple",
        internalType: "struct EulerRouterInfo",
        components: [
          { type: "address", name: "governor" },
          { type: "address", name: "fallbackOracle" },
          {
            type: "tuple",
            name: "fallbackOracleInfo",
            internalType: "struct OracleDetailedInfo",
            components: [
              { type: "address", name: "oracle" },
              { type: "string", name: "name" },
              { type: "bytes", name: "oracleInfo" },
            ],
          },
          { type: "address[]", name: "bases" },
          { type: "address[]", name: "quotes" },
          { type: "address[][]", name: "resolvedAssets" },
          { type: "address[]", name: "resolvedOracles" },
          {
            type: "tuple[]",
            name: "resolvedOraclesInfo",
            internalType: "struct OracleDetailedInfo",
            components: [
              { type: "address", name: "oracle" },
              { type: "string", name: "name" },
              { type: "bytes", name: "oracleInfo" },
            ],
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getLidoOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "lidoOracleInfo",
        type: "tuple",
        internalType: "struct LidoOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getLidoFundamentalOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "lidoFundamentalOracleInfo",
        type: "tuple",
        internalType: "struct LidoFundamentalOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getPythOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "pythOracleInfo",
        type: "tuple",
        internalType: "struct PythOracleInfo",
        components: [
          {
            name: "pyth",
            type: "address",
            internalType: "address",
          },
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "feedId",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "maxStaleness",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "maxConfWidth",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getRedstoneCoreOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "redstoneCoreOracleInfo",
        type: "tuple",
        internalType: "struct RedstoneCoreOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "feedId",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "feedDecimals",
            type: "uint8",
            internalType: "uint8",
          },
          {
            name: "maxStaleness",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "cachePrice",
            type: "uint208",
            internalType: "uint208",
          },
          {
            name: "cachePriceTimestamp",
            type: "uint48",
            internalType: "uint48",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getUniswapV3OracleInfo",
    inputs: [],
    outputs: [
      {
        name: "uniswapV3OracleInfo",
        type: "tuple",
        internalType: "struct UniswapV3OracleInfo",
        components: [
          {
            name: "tokenA",
            type: "address",
            internalType: "address",
          },
          {
            name: "tokenB",
            type: "address",
            internalType: "address",
          },
          {
            name: "pool",
            type: "address",
            internalType: "address",
          },
          {
            name: "fee",
            type: "uint24",
            internalType: "uint24",
          },
          {
            name: "twapWindow",
            type: "uint32",
            internalType: "uint32",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getFixedRateOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "fixedRateOracleInfo",
        type: "tuple",
        internalType: "struct FixedRateOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "rate",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getRateProviderOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "rateProviderOracleInfo",
        type: "tuple",
        internalType: "struct RateProviderOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "rateProvider",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getPendleOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "pendleOracleInfo",
        type: "tuple",
        internalType: "struct PendleOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "pendleMarket",
            type: "address",
            internalType: "address",
          },
          {
            name: "twapWindow",
            type: "uint32",
            internalType: "uint32",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getOndoOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "ondoOracleInfo",
        type: "tuple",
        internalType: "struct OndoOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "rwaOracle",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getSwaapSafeguardOracleInfo",
    inputs: [],
    outputs: [
      {
        name: "swaapSafeguardOracleInfo",
        type: "tuple",
        internalType: "struct SwaapSafeguardOracleInfo",
        components: [
          {
            name: "base",
            type: "address",
            internalType: "address",
          },
          {
            name: "quote",
            type: "address",
            internalType: "address",
          },
          {
            name: "poolId",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
    ],
    stateMutability: "pure",
  },
] as const
